import { useEffect, useRef } from "react";

import { useSidebar } from "@/contexts/SidebarContext";

export function useFoldMenuWhileOpen(open: boolean) {
  const { collapsed, setCollapsed } = useSidebar();
  const before = useRef<boolean | null>(null);
  const latest = useRef(collapsed);
  latest.current = collapsed;

  useEffect(() => {
    if (!open) return;
    before.current = latest.current;
    setCollapsed(true);
    return () => {
      if (before.current !== null) setCollapsed(before.current);
      before.current = null;
    };
  }, [open, setCollapsed]);
}
